import { useContext } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ThemeContext from "../../lib/theme-context";

const ConfirmDialog = ({ open, onClose, onConfirm, title, message }) => {
  const theme = useContext(ThemeContext);

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      sx={{ maxWidth: "1920px", margin: "0 auto" }}
    >
      <Box
        sx={{
          overflowY: "auto",
          overflowX: "hidden",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: theme[0] !== "dark" ? "#1a1b1e" : "#FCFCFF",
          width: "100%",
          maxWidth: "500px",
          backgroundColor: theme[0] === "dark" ? "#0f0f10" : "#f9fafb",
          border: `2px solid ${theme[0] === "dark" ? "#727272" : "#e5e7eb"}`,
          borderRadius: "16px",
          padding: "24px",
          margin: "0 auto",
          boxShadow: theme[0] === "dark" 
            ? "0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
            : "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
        }}
      >
        <Typography
          id="confirm-dialog-title"
          variant="h6"
          component="h2"
          sx={{
            color: theme[0] !== "dark" ? "#1a1b1e" : "#FCFCFF",
            marginBottom: "1em",
            fontWeight: "600",
            fontSize: "1.25rem",
            lineHeight: "1.5",
            letterSpacing: "0.5px",
          }}
        >
          {title || "Confirm Action"}
        </Typography>
        
        <Typography
          id="confirm-dialog-description"
          sx={{
            color: theme[0] !== "dark" ? "#374151" : "#9ca3af",
            marginBottom: "2em",
            lineHeight: "1.5",
            fontSize: "1rem",
            letterSpacing: "0.25px",
          }}
        >
          {message}
        </Typography>
        
        <Box sx={{ 
          display: "flex", 
          justifyContent: "flex-end", 
          gap: "1em",
          flexWrap: "wrap",
        }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              borderColor: theme[0] === "dark" ? "#1a1b1e" : "#e5e7eb",
              color: theme[0] !== "dark" ? "#1a1b1e" : "#9ca3af",
              backgroundColor: "transparent",
              padding: "12px 24px",
              borderRadius: "8px",
              fontSize: "0.875rem",
              fontWeight: "500",
              textTransform: "none",
              letterSpacing: "0.5px",
              transition: "all 0.3s ease",
              "&:hover": {
                borderColor: theme[0] === "dark" ? "#2d2e33" : "#d1d5db",
                backgroundColor: theme[0] === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.05)",
                transform: "translateY(-1px)",
              },
              "&:active": {
                transform: "translateY(0)",
              },
            }}
          >
            Cancel
          </Button>
          
          <Button
            onClick={handleConfirm}
            variant="contained"
            sx={{
              backgroundColor: "#f23645",
              color: "#ffffff",
              padding: "12px 24px",
              borderRadius: "8px",
              fontSize: "0.875rem",
              fontWeight: "500",
              textTransform: "none",
              letterSpacing: "0.5px",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 6px -1px rgba(242, 54, 69, 0.3), 0 2px 4px -1px rgba(242, 54, 69, 0.2)",
              "&:hover": {
                backgroundColor: "#dc2626",
                boxShadow: "0 10px 15px -3px rgba(242, 54, 69, 0.3), 0 4px 6px -2px rgba(242, 54, 69, 0.2)",
                transform: "translateY(-1px)",
              },
              "&:active": {
                transform: "translateY(0)",
                boxShadow: "0 4px 6px -1px rgba(242, 54, 69, 0.3), 0 2px 4px -1px rgba(242, 54, 69, 0.2)",
              },
            }}
          >
            Delete
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmDialog;
